export const NUMBER_OF_PAYING_TEAMS = "127,000";
export const NEW_YORK_ADDRESS = "34 W 14th St. New York, NY 10011, USA";
